/* eslint-disable */
import React, { Component } from 'react';
import { Alert, Button } from 'reactstrap';
import propTypes from 'prop-types';

import { isBlank } from 'lib/string';

import SessionExpiration from './SessionExpiration';

/**
 * render a user information bar
 */
export default class UserInfo extends Component {
  static propTypes = {
    firstName: propTypes.string.isRequired,
    lastName: propTypes.string.isRequired,
    lanId: propTypes.string.isRequired,
    visitLogout: propTypes.func.isRequired
  };

  render() {
    const { firstName, lastName, lanId, visitLogout } = this.props;

    return (
      <Alert color="primary" className="mb-0">
        <div className="d-flex align-items-baseline">
          <span className="mr-auto" data-test-id="userInfo-string">
            {![firstName, lastName, lanId].some(isBlank) &&
              `Welcome ${firstName} ${lastName} (${lanId})`}
          </span>
          <SessionExpiration />
          <Button color="link" onClick={visitLogout}>
            logout
          </Button>
        </div>
      </Alert>
    );
  }
}
